import type { ChangeSetStatus } from "../types/contract";

export function StatusPill({ status }: { status: ChangeSetStatus | string }): JSX.Element {
  return <span className={`pill pill-${String(status).replace(/_/g, "-")}`}>{String(status).replace(/_/g, " ")}</span>;
}
